import { render, staticRenderFns } from "./OrderExchangeReject.vue?vue&type=template&id=e49c9372&scoped=true"
import script from "./OrderExchangeReject.vue?vue&type=script&lang=js"
export * from "./OrderExchangeReject.vue?vue&type=script&lang=js"
import style0 from "./OrderExchangeReject.vue?vue&type=style&index=0&id=e49c9372&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e49c9372",
  null
  
)

export default component.exports